webpackJsonp([64249718175886],{

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Features = __webpack_require__(20);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	var _Video = __webpack_require__(15);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Features2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '404 Pages'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Useful for providing the user with a clear indication that what they\'re looking for does not exist, as infinite loaders and blank pages are both poor user experiences.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visualization'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This video demonstrates what 404 pages look like. Screenshots are from the ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'Simply Social'
	      ),
	      ' prototype that ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.invisionapp.com/' },
	        'Invision'
	      ),
	      ' provides you when you sign up for an account.'
	    ),
	    _react2.default.createElement(_Video2.default, { videoId: 's_jWh7h_j1w' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore handles 404 errors by treating them as a special case of ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/features/error-handling/' },
	        'Error Handling'
	      ),
	      '. Normally if you were fetching a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'post'
	      ),
	      ' with an ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ' of 1, and the API returned a 404 status code, the action creator blueprint would emit an action with a payload that looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      model = {\n        id: 1,\n        cid: \'c1\',\n        state: \'ERROR_FETCHING\',\n        data: {},\n        error: {\n          statusCode: 404,\n          message: \'No Post exists with id of 1\'\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'But since 404 errors have a clear and explicit use (the resource you asked for does not exist) the default blueprints treat this as a special case and set the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'state'
	      ),
	      ' to ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'NOT_FOUND'
	      ),
	      '. So instead of the generic error message above the payload will contain this more specific error message:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      model = {\n        id: 1,\n        cid: \'c1\',\n        state: \'NOT_FOUND\',\n        data: {},\n        error: {\n          statusCode: 404,\n          message: \'No Post exists with id of 1\'\n        }\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This in turn allows you to communicate "not found" experiences much easier to a user:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      createReactClass({\n\n        propTypes: {\n          post: React.PropTypes.object.isRequired\n        },\n\n        render: function() {\n          var post = this.props.post;\n\n          if (posts.state === PayloadStates.NOT_FOUND) {\n            return (\n              <div>\n                The Post you requested does not exist.\n              </div>\n            );\n          }\n\n          // todo: render RESOLVED state\n        }\n      });\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-404-pages-js-aa139414901c5bd502cf.js